// Import SASS
import '../sass/style.scss';

// Import scripts
// import './modules/navigation';
import './modules/skip-link-focus-fix';
import objectFitImages from 'object-fit-images';
import Siema from 'siema';


// Veelgebruikte modules:
// ------------------------
// Lightbox		-->		import baguetteBox from 'baguettebox.js';
// Viewport		-->		import inView from 'in-view';
// Smoothscroll	-->		import MoveTo from 'moveto';
// Sticky div	-->		import Sticky from 'sticky-js';
// Slider		-->		import { tns } from 'tiny-slider/src/tiny-slider.module.js';
// Modals		-->		import modals from 'Modals';

// Hamburger menu
document.querySelector("#nav-toggle").addEventListener("click", function () {
	this.classList.toggle("active");
	let mainNav = document.querySelector('.main-navigation');
	mainNav.classList.toggle('toggled');
});

if (document.querySelector(".donaties")) {
	document.querySelector(".donaties label").addEventListener("click", function () {
		this.classList.add("active");
	});
}


// Object-fit fix
objectFitImages();

		const testimonialSiema = new Siema({
		  selector: '.siema__testimonials',
		  interval: 10000,
		  duration: 500,
		  perPage: 1,
		  startIndex: 0,
		  draggable: true,
		  threshold: 20,
		  loop: true
		});
		// listen for keydown event
		setInterval(() => testimonialSiema.next(), 5000)


		const headerSiema = new Siema({
		  selector: '.siema__header',
		  interval: 10000,
		  duration: 1000,
		  perPage: 1,
		  startIndex: 0,
		  draggable: true,
		  threshold: 20,
		  loop: true
		});
		setInterval(() => headerSiema.next(), 10000)





// WEBPACK FOOTER //
// ./js/app.js